import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      margin-left: auto;\n      margin-right: auto;\n      max-width: ", ";\n      width: 100%;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      min-width: ", ";\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  padding: ", ";\n\n  ", ";\n\n  ", ";\n\n  @media screen and (max-width: ", "px) {\n    padding: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { size } from '@scp/ui-shared/theme/variables';
import { baselineToRem } from '@scp/ui-shared/theme/utils';
var PROPS_TO_OMIT = ['maxWidth', 'minWidth', 'noPadding'];
export var PageWidth;

(function (PageWidth) {
  PageWidth[PageWidth["LargeMin"] = 357] = "LargeMin";
  PageWidth[PageWidth["LargeMax"] = 400] = "LargeMax";
  PageWidth[PageWidth["MediumMin"] = 262] = "MediumMin";
})(PageWidth || (PageWidth = {}));

export var ContentWrapper = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !PROPS_TO_OMIT.includes(prop);
  }
})(_templateObject(), function (_ref) {
  var noPadding = _ref.noPadding;
  return noPadding ? 0 : "".concat(baselineToRem(6), " ").concat(baselineToRem(12));
}, function (_ref2) {
  var minWidth = _ref2.minWidth;
  return minWidth && css(_templateObject2(), baselineToRem(minWidth));
}, function (_ref3) {
  var maxWidth = _ref3.maxWidth;
  return maxWidth && css(_templateObject3(), baselineToRem(maxWidth));
}, size.breakpointSmall - 1, function (_ref4) {
  var noPadding = _ref4.noPadding;
  return noPadding ? 0 : "".concat(baselineToRem(6), " ").concat(baselineToRem(4));
});